<template>
    <v-container class="pt-0 pb-0">
        <v-row
            align='center'
        >
            <v-col cols="4">
                <v-card 
                    tile
                    width="230"
                    class="py-0"
                    flat
                >
                    <v-list 
                        dense
                        flat
                        class="pa-0"
                        two-line
                    >
                        <v-list-item-group color="primary">
                            
                            <v-list-item>                                
                                <v-list-item-content
                                    class="pa-0 mb-3"
                                >
                                    <v-list-item-title class="mb-4">
                                        <span class="pr-1">Year:</span><span class="font-weight-bold">{{ academicYear }}</span>                                    
                                    </v-list-item-title>                                    
                                    <v-list-item-title>
                                        <span class="pr-1">Term:</span><span class="font-weight-bold">{{ term }}</span>                                    
                                    </v-list-item-title>                                    
                                </v-list-item-content> 
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>                    
                    
                </v-card>                
            </v-col>
            <v-col
                cols="4"
            >
                <div class="d-flex pa-1">
                    <v-select
                        label="Class"
                        class="mr-1 caption centered-input small-input"
                        dense
                        outlined                        
                        v-model="selectedClasses"
                        multiple
                        hide-details
                        :items="lessonClasses"
                        item-text="form_class_id"
                        item-value="form_class_id"
                        small-chips
                        deletable-chips
                        @change="filterStudentsByClass"
                    ></v-select>
                    
                </div>
            </v-col>
            <v-col cols="1"></v-col>                         
            <v-col
                cols="3"
            >
                <v-btn  
                    color="primary"
                    dark
                    @click="nextSubjectClass"
                >Next Subject Class</v-btn>
            </v-col>          
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
    watch: {
        studentSelected: {
            handler: function (val) {
                //console.log('marksheetheader:', val);
                this.studentName = val.studentName;
                if(val.picture === null){
                    this.imageSrc = null;
                }
                else{
                    this.imageSrc = "/img/students/" + val.picture;                    
                }
            },
            deep: true,
        },
        
        studentsRegistered: {
            handler: function (val) {
                console.log('studentsRegistered:', val);
                this.classSummary[1].value = val;
            }
        },
        studentsMarksEntered: {
            handler: function (val) {
                this.classSummary[2].value = val;
            }
        },

        termMarkRecords: {
            handler: function (val) {
                if(val.length > 0) {
                    // this.selectedClasses = [...this.lessonClasses];
                    // console.log(this.lessonClassesWithStudents)
                    this.selectedClasses = [...this.lessonClassesWithStudents]

                }
            }
        }
    },

    computed: {
        ...mapGetters({
            academicYear: 'app/getAcademicYear',
            term: 'app/getTerm',
            lessonSelected: 'markSheet/getLessonSelected',
            studentsTotal: 'markSheet/getTotalStudents', 
            lessonClasses: 'markSheet/getLessonClasses', 
            termMarkRecords: 'markSheet/getTermMarkRecords',
            lessonClassesWithStudents: 'markSheet/getLessonClassesWithStudents',          
        }),        
           
    },

    data(){
        return {                     
            nameLabel: "Name",
            imageSrc: '',
            studentName: '',
            selectedClasses: [],          
        }
    },

    methods: {
        ...mapMutations({
            setOverlay: 'markSheet/setMarkSheetOverlay',
            setTermMarkRecords: 'markSheet/setTermMarkRecords', 
            setDisplayLessons: 'markSheet/setDisplayLessons',           
        }),

        nextSubjectClass(){
            this.setTermMarkRecords([]);
            this.setOverlay(true);
            this.setDisplayLessons(true);
        },

        filterStudentsByClass(){
            this.$emit('filter-students-by-class', this.selectedClasses);
        }    
    }
}
</script>

<style scoped>
    .centered-input >>> input{
        text-align: center;
    }
    .small-input >>> input{
        width: 35px;;
    }
    .v-list-item{
        min-height: 0;
    } 
    .term-name >>> input{
        width: 100px !important
    } 
    
    ::v-deep .v-select__slot{
        padding-top: 5px;
    }
</style>